// Nepovinné jméno mazlíčka → poznámka objednávky („Jméno mazlíčka: …“).
// Delegace na document, protože vysouvací košík se po každé změně překresluje.
// Skript se načítá z košíku i z vysouvacího košíku, proto pojistka proti dvojímu navázání.
if (!window.aetheroPetNameInit) {
  window.aetheroPetNameInit = true;

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.js-pet-name')) return;
    const puppyName = e.target.value.trim();

    document.querySelectorAll('.js-pet-name').forEach(function (input) {
      if (input !== e.target) input.value = e.target.value;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: puppyName ? `Jméno mazlíčka: ${puppyName}` : ''
      })
    }).catch((error) => {
      console.error('Chyba při ukládání jména mazlíčka:', error);
    });
  });
}
